import React from 'react';

const items = [
  {
    emoji: '⚡',
    title: 'One-tap installation',
    description: 'Send faces and wallpapers straight to the Watch app with automatic complication pairing. No fiddling.',
  },
  {
    emoji: '🎨',
    title: 'Weekly Creator Drops',
    description: 'Exclusive collaborations with independent designers. Fresh styles every week, never the same wrist twice.',
  },
  {
    emoji: '🎯',
    title: 'Focus-based scheduling',
    description: 'Set your watch face to change automatically when Work, Sports, or Lifestyle Focus turns on.',
  },
  {
    emoji: '📡',
    title: 'Live smart widgets',
    description: 'Dynamic complications that adapt to weather, events, or time zones without you lifting a finger.',
  },
];

const Highlights: React.FC = () => {
  return (
    <section
      className="py-24"
      style={{
        background: 'linear-gradient(180deg, #080C0B 0%, #0D1614 100%)',
      }}
    >
      <div className="container mx-auto">
        <div className="text-center mb-14">
          <span className="section-badge mb-4 inline-flex">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#68C1AE]" />
            Why Watchi
          </span>
          <h2 className="mt-4 text-4xl md:text-5xl font-extrabold text-white tracking-tight" style={{ letterSpacing: '-0.03em' }}>
            Built for{' '}
            <span className="gradient-text">Smart Watch</span>{' '}
            obsessives.
          </h2>
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          {items.map((item, i) => (
            <div
              key={i}
              className="group rounded-3xl p-7 hover-lift cursor-default"
              style={{
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(255,255,255,0.07)',
                transition: 'border-color 0.3s ease',
              }}
              onMouseEnter={e => (e.currentTarget.style.borderColor = 'rgba(104,193,174,0.25)')}
              onMouseLeave={e => (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)')}
            >
              <span className="text-3xl">{item.emoji}</span>
              <h3 className="mt-4 text-xl font-bold text-white" style={{ letterSpacing: '-0.02em' }}>{item.title}</h3>
              <p className="mt-2 text-[15px] text-white/50 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Highlights;
